import { render, staticRenderFns } from "./Cartola.vue?vue&type=template&id=cf603134&scoped=true&"
import script from "./Cartola.vue?vue&type=script&lang=js&"
export * from "./Cartola.vue?vue&type=script&lang=js&"
import style0 from "./Cartola.vue?vue&type=style&index=0&id=cf603134&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf603134",
  null
  
)

export default component.exports